import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/index.jsx";
import { strings } from "../utils/index.js";
import { getAllTestCases, deleteTestCase } from "../utils/methods.js";
import TestCaseArrowIcon from "../components/Icons/blogsArrow.jsx";
import { DefaultBlogImage } from "../assets/images/index.js";
import ModalScreen from "../components/modal.jsx";
import DeleteIcon from "../components/Icons/deleteIcon.jsx";
import { CircularProgress } from "@mui/material";

const CaseStudies = () => {
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedTestId, setSelectedTestId] = useState(null);
    const [loading, setLoading] = useState(null);
    const [testCases, setTestCases] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchTestCases = async () => {
            setLoading(true);
            try {
                const testData = await getAllTestCases();
                setTestCases(testData);
            } catch (error) {
                console.error("Error fetching test cases:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchTestCases();
    }, []);

    const handleAddTestCase = () => navigate(`/caseStudies/edit/new`);

    const handleClickOpen = (testId) => {
        setSelectedTestId(testId);
        setOpenDialog(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
        setSelectedTestId(null);
    };

    const handleDeleteTestCase = async () => {
        try {
            if (selectedTestId) {
                await deleteTestCase(selectedTestId);
                setTestCases((prevTests) =>
                    prevTests.filter((test) => test.id !== selectedTestId)
                );
            }
            handleClose();
        } catch (error) {
            console.error("Error deleting test case:", error);
        }
    };

    const handleOpenExternalPage = (url) => {
        if (url) {
            const fullUrl = `https://www.exeonic.com/case-studies/${url}`;
            window.open(fullUrl, "_blank");
        }
    };

    return (
        <div className="container px-auto py-6 bg-border h-full overflow-scroll">
            <div className="flex justify-between mx-10 mb-8">
                <p className="text-[32px] font-semibold">{strings["TestCasesPageTitle"]}</p>
                <Button onClick={handleAddTestCase}>{strings["AddTestCaseBtn"]}</Button>
            </div>

            {loading ? (
                <div className="flex justify-center items-center">
                    <CircularProgress />
                </div>
            ) : testCases.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mx-10">
                    {testCases.map((testCase) => (
                        <div
                            key={testCase.id}
                            className="border rounded-2xl p-4 shadow-md flex flex-col justify-between"
                        >
                            <img
                                src={`${testCase.testCaseImage}?t=${new Date().getTime()}`}
                                alt={testCase.title}
                                className="h-[120px] object-cover w-full rounded-md"
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = DefaultBlogImage;
                                }}
                            />
                            <p className="text-sm font-semibold text-primary pt-3">
                                {testCase.category}
                            </p>
                            <div className="flex justify-between py-3" onClick={() => handleOpenExternalPage(testCase.id)}>
                                <h2 className="text-2xl font-semibold">{testCase.title}</h2>
                                <TestCaseArrowIcon />
                            </div>
                            <div className="flex gap-x-2 w-full">
                                <Button
                                    variant="outlineArrow"
                                    classes="border-primary text-primary !w-full justify-center"
                                    onClick={() => navigate(`/caseStudies/edit/${testCase.id}`)}
                                >
                                    {strings["blogEditBtn"]}
                                </Button>
                                <Button

                                    classes="!w-full justify-center"
                                    onClick={() => handleClickOpen(testCase.id)}
                                >
                                    {strings["DeleteBtn"]}
                                </Button>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="flex w-full justify-center items-center mt-10">
                    <p>No test cases found.</p>
                </div>
            )}

            <ModalScreen
                open={openDialog}
                onClose={handleClose}
                onConfirm={handleDeleteTestCase}
                title={strings["deleteTestCase"]}
                description={strings["deleteTestCaseDesc"]}
                confirmButtonText={strings["DeleteBtn"]}
                cancelButtonText={strings["cancelBtn"]}
                hideClass="hidden"
                icon={DeleteIcon}
            />
        </div>
    );
};

export default CaseStudies;
